<v4-base-selector-body
  class="block h-[600px]"
  [mode]="mode"
  [showExtra]="true"
  [listOfOption]="listOfData"
  [listOfExtraOption]="listOfExtraData"
  [selectedValues]="selectedValues"
  (onConfirm)="onConfirm($event)"
  (onCancel)="onCancel()"
  (onReset)="onReset()">
  <div class="v4-base-selector-body_filters v4-filter-list" [formGroup]="form">
    <div class="v4-filter-item">
      <input type="text" nz-input [placeholder]="'word.search' | translate" formControlName="title" />
    </div>
    <div class="v4-filter-item">
      <host-select
        class="v4-filter-style"
        [placeholder]="'word.group' | translate"
        formControlName="group_id"
        [listOfOption]="listOfGroupOption"
        [defaultValue]="null"></host-select>
    </div>
    <div class="v4-filter-item">
      <host-select
        class="v4-filter-style"
        [placeholder]="'word.house_type' | translate"
        formControlName="house_type_id"
        [listOfOption]="listOfHouseTypeOption"
        [defaultValue]="null"></host-select>
    </div>
    <div class="v4-filter-item">
      <host-select
        class="v4-filter-style"
        [placeholder]="'word.tag' | translate"
        formControlName="house_tag_id"
        [listOfOption]="listOfTagOption"
        [defaultValue]="null"></host-select>
    </div>
  </div>
</v4-base-selector-body>
